import { render } from "./ArchiveButton.vue?vue&type=template&id=a519ee5a"
import script from "./ArchiveButton.vue?vue&type=script&lang=js"
export * from "./ArchiveButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__